import { BaseMutations } from '@/store/base-mutations';
import { Staffs, StaffsFilters } from '@/modules/staffs/types';
import { Organizations } from '@/modules/organizations/types';
import { clone_deep } from '@/utils';
import CompanyUserStaffState from './state';

export default class CompanyUserStaffMutations extends BaseMutations<CompanyUserStaffState> {
  UPD_FILTER_KEY({ key, value }: { key: keyof StaffsFilters | string; value: unknown }) {
    this.state.filters[key] = value;
  }

  // receiving and handling data from server

  TOGGLE_LOADING_COMPANY_USER_STAFF(toggle: boolean) {
    this.state.company_user_staff_loading = toggle;
  }

  SET_COMPANY_USER_STAFF(company_user_staff: Staffs.Staff[]) {
    this.state.company_user_staff = company_user_staff;
  }

  SET_CURRENT_USER_COMPANY(company: Organizations.Organization) {
    this.state.current_user_company = company;
  }

  SET_CURRENT_STAFF(staff: Staffs.Staff) {
    this.state.current_staff = staff;
  }

  UPD_CURRENT_STAFF_FIELD({ key, value }: { key: keyof Staffs.Staff, value: unknown }) {
    this.state.current_staff[key] = value;
  }

  RESET_EDITABLE_STAFF() {
    this.state.editable_staff = clone_deep(this.state.current_staff);
  }

  UPD_EDITABLE_FIELD({ key, value }: { key: keyof Staffs.Staff, value: unknown }) {
    this.state.editable_staff[key] = value;
  }
}
